<template>
  <div class="control checkbox">
    <span class="radio-validate">
        <span
          class="icon is-small is-right has-text-danger"
          v-if="!fieldValidator && field.validation.required"
        >
          <fa icon="asterisk" class="fa-xs"></fa>
        </span>
        <span
          class="icon is-small is-right has-text-success"
          v-if="fieldValidator"
        >
          <fa icon="check"></fa>
        </span>
    </span>
    <label class="checkbox is-grouped" v-for="(label, name) in field.options" :key="name">
      <input
        type="checkbox"
        class="checkbox-other"
        :name="`${field.name}-${name}`"
        @click="updateFormData"
        v-if="name === 'other'"
        v-model="other"
      >
      <input type="checkbox" :name="`${field.name}-${name}`" @click="updateFormData" v-else>
      {{label}}
      <FormInput
        :field="otherObject"
        v-if="name === 'other' && other"
        class="checkbox-other-input"
      />
    </label>
  </div>
</template>

<script>
import FormInput from '@/components/Form/Input.vue';

export default {
  data() {
    return {
      hasAnswered: false,
      other: null,
    };
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fieldValidator() {
      return this.hasAnswered;
    },
    // otherInputDisabled() {
    //   return otherChecked?'':'disabled';
    // },
    otherObject() {
      return {
        name: `${this.field.name}-other-answer`,
        disabled: true,
        type: 'input',
        validation: {},
        class: 'is-small is-inline',
      };
    },
  },
  methods: {
    updateFormData(e) {
      this.hasAnswered = true;
      this.$store.dispatch('addToSubmission', {
        name: e.target.name,
        value: e.target.value,
      });
    },
  },
  mounted() {
    this.$store.dispatch('addToSubmission', {
      name: this.field.name,
      value: null,
    });
  },
  components: {
    FormInput,
  },
};
</script>
